export const AUTH = {
  TOKEN: 'tkn',
};
